import { render, staticRenderFns } from "./Content4.vue?vue&type=template&id=72526128&scoped=true"
import script from "./Content4.vue?vue&type=script&lang=js"
export * from "./Content4.vue?vue&type=script&lang=js"
import style0 from "./Content4.vue?vue&type=style&index=0&id=72526128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72526128",
  null
  
)

export default component.exports